export type PortalSchemaRestrictions = {
  disableEditContent?: boolean;
  disableEditTheming?: boolean;
  disableEditSnippets?: boolean;
};

const isObject = (value: unknown): value is Record<string, unknown> => value !== null && typeof value === "object";

// session.userInfo is the full JWT payload at runtime but typed minimally by the SDK.
// This extracts portalSchemaRestrictions safely without type assertions by narrowing
// each field individually.
export const getPortalSchemaRestrictions = (userInfo: object): PortalSchemaRestrictions | undefined => {
  if (!isObject(userInfo) || !isObject(userInfo["portalSchemaRestrictions"])) return undefined;
  const r = userInfo["portalSchemaRestrictions"];
  return {
    ...(typeof r["disableEditContent"] === "boolean" && { disableEditContent: r["disableEditContent"] }),
    ...(typeof r["disableEditTheming"] === "boolean" && { disableEditTheming: r["disableEditTheming"] }),
    ...(typeof r["disableEditSnippets"] === "boolean" && { disableEditSnippets: r["disableEditSnippets"] }),
  };
};
